import React from "react";
import TrinsicStart from "../trinsic/TrinsicStart";
import BankIdLogo from "../../../assets/bankid_cz.svg";
import {
  IconBolt,
  IconLock,
  IconHeart,
} from "@tabler/icons-react";
import useLocale from "../../../hooks/useLocale";

const BankIdCzStart = () => {
  const locale = useLocale("bankid-cz");

  const bankIdFeatures = [
    { icon: IconBolt, text: locale.features.feature1 },
    { icon: IconLock, text: locale.features.feature2 },
    { icon: IconHeart, text: locale.features.feature3 },
  ];

  return (
    <TrinsicStart
      providerName="BANKID_CZ"
      providerDisplayName="BankID"
      logo={BankIdLogo}
      logoWidth={100}
      title={locale.title}
      features={bankIdFeatures}
      poweredByText={locale.poweredBy}
      getStartedText={locale.getStarted}
    />
  );
};

export default BankIdCzStart;
